/* MBD Marketplace — page logic: product, collection/search filters, cart */
(function () {
  'use strict';
  var M = window.MBD, $ = M.$, $$ = M.$$;

  /* quantity selector (shared) */
  function initQty(q, onChange) {
    var input = $('input', q), minus = $('[data-qty-minus]', q), plus = $('[data-qty-plus]', q);
    function clamp(v) { var max = Number(input.getAttribute('max')) || 9999; v = Math.max(1, Math.min(max, parseInt(v, 10) || 1)); return v; }
    function set(v, fire) { v = clamp(v); input.value = v; minus.disabled = v <= 1; plus.disabled = v >= (Number(input.getAttribute('max')) || 9999); if (fire && onChange) onChange(v); }
    minus.addEventListener('click', function () { set(Number(input.value) - 1, true); });
    plus.addEventListener('click', function () { set(Number(input.value) + 1, true); });
    input.addEventListener('change', function () { set(input.value, true); });
    set(input.value, false);
    q.__set = set;
  }

  /* ---------- product ---------- */
  function initProduct(root) {
    if (root.__mbd) return; root.__mbd = 1;
    var variants = JSON.parse(($('[data-mbd-variants]', root) || {}).textContent || '[]');
    var form = $('form[action*="/cart/add"]', root);
    var idInput = $('[data-mbd-variant-id]', root), qtyBox = $('[data-mbd-qty]', root), qtyInput = qtyBox && $('input', qtyBox);
    var groups = $$('[data-mbd-option]', root);
    var track = $('[data-mbd-gallery-track]', root), thumbs = $$('[data-mbd-thumb]', root), counter = $('[data-mbd-gallery-index]', root);
    M.trackRecent(root.getAttribute('data-handle'));
    if (qtyBox) initQty(qtyBox);

    function goSlide(i) { if (!track) return; track.scrollTo({ left: i * track.clientWidth }); }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goSlide(Number(t.getAttribute('data-mbd-thumb'))); }); });
    var gp = $('[data-mbd-gallery-prev]', root), gn = $('[data-mbd-gallery-next]', root);
    function curIdx() { return track ? Math.round(track.scrollLeft / Math.max(1, track.clientWidth)) : 0; }
    if (gp) gp.addEventListener('click', function () { goSlide(Math.max(0, curIdx() - 1)); });
    if (gn) gn.addEventListener('click', function () { goSlide(Math.min(thumbs.length - 1, curIdx() + 1)); });
    if (track) track.addEventListener('scroll', M.debounce(function () {
      var i = curIdx();
      if (counter) counter.textContent = i + 1;
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      if (thumbs[i]) thumbs[i].scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }, 60), { passive: true });

    function selected() { return groups.map(function (g) { var s = $('.mbd-opt.is-selected', g); return s ? s.getAttribute('data-value') : null; }); }
    function find(opts) { return variants.filter(function (v) { return v.options.every(function (o, i) { return opts[i] == null || o === opts[i]; }); })[0]; }
    function markAvailability(opts) {
      groups.forEach(function (g, gi) {
        $$('.mbd-opt', g).forEach(function (b) {
          var test = opts.slice(); test[gi] = b.getAttribute('data-value');
          var ok = variants.some(function (v) { return v.available && v.options.every(function (o, i) { return o === test[i]; }); });
          b.classList.toggle('is-unavailable', !ok);
        });
      });
    }
    function update(v) {
      var price = $('[data-mbd-price]', root), cmp = $('[data-mbd-compare]', root), pct = $('[data-mbd-pct]', root), sku = $('[data-mbd-sku]', root), stock = $('[data-mbd-stock]', root);
      var atc = $$('[data-mbd-atc]', root), buy = $$('[data-mbd-buy]', root);
      if (!v) {
        atc.concat(buy).forEach(function (b) { b.disabled = true; });
        buy.forEach(function (b) { b.textContent = 'Không có phân loại này'; });
        if (stock) stock.textContent = '';
        return;
      }
      idInput.value = v.id;
      price.textContent = M.formatMoney(v.price);
      var sale = v.compare > v.price;
      cmp.hidden = pct.hidden = !sale;
      if (sale) { cmp.textContent = M.formatMoney(v.compare); pct.textContent = '-' + Math.max(1, Math.floor((v.compare - v.price) * 100 / v.compare)) + '%'; }
      if (sku) sku.textContent = v.sku || '—';
      atc.concat(buy).forEach(function (b) { b.disabled = !v.available; });
      buy.forEach(function (b) { b.textContent = v.available ? 'Mua ngay' : 'Hết hàng'; });
      if (stock) {
        if (!v.available) { stock.textContent = 'Hết hàng'; stock.classList.add('is-low'); }
        else if (v.tracked && v.qty > 0) { stock.textContent = 'Còn ' + v.qty + ' sản phẩm'; stock.classList.toggle('is-low', v.qty <= 5); }
        else { stock.textContent = 'Còn hàng'; stock.classList.remove('is-low'); }
      }
      if (qtyInput) { if (v.tracked && v.qty > 0) qtyInput.setAttribute('max', v.qty); else qtyInput.removeAttribute('max'); qtyBox.__set(qtyInput.value, false); }
      if (v.media && track) { var slide = $('[data-media-id="' + v.media + '"]', track); if (slide) goSlide($$('.mbd-gallery__slide', track).indexOf(slide)); }
      if (history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString()); }
    }
    groups.forEach(function (g) {
      g.addEventListener('click', function (e) {
        var b = e.target.closest('.mbd-opt'); if (!b) return;
        $$('.mbd-opt', g).forEach(function (x) { x.classList.toggle('is-selected', x === b); x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        var opts = selected(); markAvailability(opts); update(find(opts));
      });
    });
    if (groups.length) markAvailability(selected());

    function qty() { return qtyInput ? Number(qtyInput.value) || 1 : 1; }
    function busy(btns, on) { btns.forEach(function (b) { b.classList.toggle('is-loading', on); }); }
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btns = $$('[data-mbd-atc]', root); busy(btns, true);
      M.addToCart(idInput.value, qty()).then(M.addedToast).catch(M.cartError).finally(function () { busy(btns, false); });
    });
    $$('[data-mbd-buy]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var btns = $$('[data-mbd-buy]', root); busy(btns, true);
        M.addToCart(idInput.value, qty()).then(function () { location.href = M.root() + '/checkout'; }).catch(function (err) { busy(btns, false); M.cartError(err); });
      });
    });

    var col = $('[data-mbd-collapse]', root);
    if (col && col.scrollHeight > 640) {
      col.classList.add('is-collapsed');
      var wrap = document.createElement('div'); wrap.className = 'mbd-collapse__btn';
      wrap.innerHTML = '<button type="button" class="mbd-btn mbd-btn--ghost">Xem thêm</button>';
      col.after(wrap);
      wrap.firstChild.addEventListener('click', function () { var c = col.classList.toggle('is-collapsed'); wrap.firstChild.textContent = c ? 'Xem thêm' : 'Thu gọn'; });
    }
  }

  /* ---------- collection / search ---------- */
  function initFilters(root) {
    if (root.__mbd) return; root.__mbd = 1;
    var form = $('[data-mbd-filter-form]', root);
    if (form) {
      form.addEventListener('change', function (e) { if (e.target.matches('[data-mbd-autosubmit]')) submitFilters(form); });
      form.addEventListener('submit', function (e) { e.preventDefault(); submitFilters(form); });
      $$('[data-mbd-facet-more]', form).forEach(function (b) { b.addEventListener('click', function () { var l = b.previousElementSibling; var x = l.classList.toggle('is-expanded'); b.firstChild.textContent = x ? 'Thu gọn ' : 'Thêm '; }); });
    }
    $$('[data-mbd-sort]', root).forEach(function (b) { b.addEventListener('click', function () { setSort(b.getAttribute('data-mbd-sort')); }); });
    $$('[data-mbd-sort-select]', root).forEach(function (s) { s.addEventListener('change', function () { if (s.value) setSort(s.value); }); });
  }
  function submitFilters(form) {
    var params = new URLSearchParams();
    new FormData(form).forEach(function (v, k) { if (v !== '' && v != null) params.append(k, v); });
    params.delete('page');
    location.href = form.getAttribute('action') + '?' + params.toString();
  }
  function setSort(v) { var u = new URL(location.href); u.searchParams.set('sort_by', v); u.searchParams.delete('page'); location.href = u.toString(); }

  /* ---------- cart ---------- */
  function initCart(root) {
    if (root.__mbd) return; root.__mbd = 1;
    var sectionId = root.getAttribute('data-section-id');
    function rerender(cart) {
      if (cart) M.setCartCount(cart.item_count);
      return fetch(location.pathname + '?section_id=' + encodeURIComponent(sectionId)).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html'), fresh = doc.querySelector('[data-mbd-cart]');
        var host = root.parentNode;
        if (fresh && host) { host.innerHTML = fresh.outerHTML; var nr = host.querySelector('[data-mbd-cart]'); initCart(nr); M.markLoaded(nr); }
      });
    }
    function post(url, body) {
      return fetch(M.root() + url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); });
    }
    function change(line, quantity, row) {
      if (row) row.classList.add('is-loading');
      post('/cart/change.js', { line: Number(line), quantity: quantity }).then(rerender).catch(function (err) { if (row) row.classList.remove('is-loading'); M.cartError(err); });
    }
    $$('.mbd-cart-item', root).forEach(function (row) {
      var line = row.getAttribute('data-line'), q = $('[data-mbd-qty]', row);
      if (q) initQty(q, M.debounce(function (v) { change(line, v, row); }, 350));
      var rm = $('[data-mbd-cart-remove]', row);
      if (rm) rm.addEventListener('click', function () { change(line, 0, row); });
    });
    var df = $('[data-mbd-discount-form]', root);
    if (df) df.addEventListener('submit', function (e) {
      e.preventDefault();
      var code = $('input', df).value.trim(); if (!code) return;
      var existing = (root.getAttribute('data-codes') || '').split(',').filter(Boolean);
      if (existing.indexOf(code) < 0) existing.push(code);
      var btn = $('button', df); btn.classList.add('is-loading');
      post('/cart/update.js', { discount: existing.join(',') }).then(function (cart) {
        var found = (cart.discount_codes || []).filter(function (d) { return d.code.toLowerCase() === code.toLowerCase(); })[0];
        if (found && !found.applicable) M.toast('Mã ' + code + ' chưa áp dụng được cho giỏ hàng này', 'error');
        else M.toast('Đã áp dụng mã ' + code);
        return rerender(cart);
      }).catch(function () { M.toast('Không áp dụng được mã giảm giá', 'error'); btn.classList.remove('is-loading'); });
    });
    $$('[data-mbd-code-remove]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var rm = b.getAttribute('data-mbd-code-remove');
        var rest = (root.getAttribute('data-codes') || '').split(',').filter(function (c) { return c && c !== rm; });
        post('/cart/update.js', { discount: rest.join(',') }).then(rerender);
      });
    });
    var note = $('[data-mbd-cart-note]', root);
    if (note) note.addEventListener('input', M.debounce(function () { post('/cart/update.js', { note: note.value }); }, 500));
  }

  /* footer newsletter feedback */
  function initNews(f) {
    if (location.search.indexOf('customer_posted=true') > -1) { var m = $('[data-mbd-news-msg]', f); if (m) { m.textContent = 'Cảm ơn bạn đã đăng ký nhận tin!'; m.className = 'mbd-footer__msg is-ok'; } }
  }

  M.initPages = function (scope) {
    $$('[data-mbd-product]', scope).forEach(initProduct);
    $$('[data-mbd-plp]', scope).forEach(initFilters);
    $$('[data-mbd-cart]', scope).forEach(initCart);
    $$('[data-mbd-news]', scope).forEach(initNews);
  };
})();